import { Component, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { GitlabIssueService } from "../../models/integrations/gitlab-issue.service";

@Component({
  selector: "ab-gitlab-integration",
  templateUrl: "./gitlab.component.html",
})
export class GitlabIntegrationComponent implements OnInit {
  @Input() public fields: any;
  @Input() public notice: any;

  public loading: boolean;
  public issue: any;
  public creatingIssue: boolean;
  public error: any;
  public removingIssue: boolean;

  constructor(private gitlabIssueService: GitlabIssueService) {}

  public ngOnInit() {
    this.loading = true;
    return this.gitlabIssueService
      .get(this.notice)
      .pipe(
        finalize(() => {
          delete this.loading;
        }),
      )
      .subscribe((issue: any) => {
        this.issue = issue;
      });
  }

  public createIssue() {
    this.issue = { notice: this.notice };

    this.creatingIssue = true;
    return this.gitlabIssueService
      .create(this.issue)
      .pipe(
        finalize(() => {
          delete this.creatingIssue;
        }),
      )
      .subscribe((data: any) => {
        if (data.error) {
          this.error = data.error;
        }
      });
  }

  public removeIssue() {
    this.issue = { notice: this.notice };

    this.removingIssue = true;
    return this.gitlabIssueService
      .destroy(this.issue)
      .pipe(
        finalize(() => {
          delete this.removingIssue;
        }),
      )
      .subscribe(() => {
        delete this.issue;
      });
  }
}
